import MetricManager from './MetricManager';

export default MetricManager;
